import React from 'react';
import _ from "underscore";
import axios from "axios";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import config from "./config";
import Loader from "./components/common/Loader";
import bindActionCreators from "redux/src/bindActionCreators";
import connect from "react-redux/es/connect/connect";
import {closeLoginModal} from "./components/actionCreators/appAC";
import {renderAuthPopup} from "./components/actionCreators/pdpAC";
import {
    authCheck,
    displayAttentiveModal,
    getCookie,
    getTierByTierKey,
    isBetweenDates,
    validateEmail
} from "./components/common/utils";
import CreditCardsImage from '../public/img/credit-cards.svg';
import Button from "react-bootstrap/Button";
import LogoutModal from "./components/Login/LogoutModal";
import TradeInLoader from "./components/common/TradeInLoader";
import OfferCodeThankYouModal from "./components/OfferCoupon/OfferCodeThankYouModal";
import LazyLoad from "react-lazyload";
import FooterLink from "./components/Footer/FooterLink";
import FooterItem from "./components/Footer/FooterItem";
import FooterLinkB2b from "./components/Footer/FooterLinkB2b";
import {AppStore} from "./components/common/Icons";
import appErrorLogger from "./components/common/DataDogErrorLog";
import ReactHtmlParser from "react-html-parser"
import RetinaImage from "react-retina-image";
import InlineSpinner from "./components/common/InlineSpinner";

class Hooter extends React.Component {
    constructor() {
        super();

        this.state = {
            footer_signup_container_input: "",
            footer_signup_container_input_invalid: false,
            footer_signup_container_request_sent: false,
            footer_signup_container_request_message: null,
            eventKey: null,
            show_offer_thank_you: false,
            disable_nl_button: false
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.showHideMenus = this.showHideMenus.bind(this);
        this.dismissModal = this.dismissModal.bind(this);

        window.rebagFooter = this;
    }

    showHideMenus(eventKey) {
        this.setState({eventKey: eventKey});
    };

    dismissModal() {
        this.setState({
            show_offer_thank_you: false
        })
    }

    handleSubmit() {
        const {footer_signup_container_input} = this.state;
        const that = this;

        if (!validateEmail(footer_signup_container_input)) {
            this.setState({
                footer_signup_container_input_invalid: true
            });
            return false;
        }

        this.setState({
                footer_signup_container_request_sent: true
            },
            () => axios.post(`${config.host_rebag_api}/trendlee/subscribe/`, {
                email: footer_signup_container_input
            })
                .then(function (response) {
                    try {
                        window.userEmail = footer_signup_container_input;
                        window.dataLayer.push({
                            'event': 'NLFooterSubscribe',
                        });
                    } catch (err) {
                        appErrorLogger('NLFooterSubscribe GTM', err)
                    }

                    that.setState({
                        footer_signup_container_request_sent: false,
                        footer_signup_container_state: "",
                        footer_signup_container_input: "",
                        show_offer_thank_you: true
                    });
                })
                .catch(function (error) {
                    that.setState({
                        footer_signup_container_request_sent: false
                    });
                    if (error && error.response && error.response.status === 409) {
                        that.setState({
                            footer_signup_container_request_message: "That email address is already in our database."
                        });
                    } else {
                        that.setState({
                            footer_signup_container_request_message: "An error has occurred. Please try again later!"
                        });
                    }
                    setTimeout(() => {
                        that.setState({
                            footer_signup_container_request_message: null
                        });
                    }, 5000);
                })
        )
    }

    showAttentiveModal = () => {
        this.setState({
            disable_nl_button: true
        }, () => displayAttentiveModal())
        setTimeout(() => {
            this.setState({disable_nl_button: false})
        }, 3000)
    }

    render() {
        const auth_token = getCookie('auth_token');
        const {
            footer_signup_container_request_sent,
            footer_signup_container_request_message,
            footer_signup_container_input_invalid,
            show_offer_thank_you, disable_nl_button
        } = this.state;
        const {
            show_logout_modal, logout_modal_settings,
            mobile_small, user_profile, mobile_big,
            init
        } = this.props;
        const is_coupon_code_page = window.location.pathname === "/customer-offer-coupon-code/";
        const is_b2b = user_profile ? user_profile.is_b2b : false;
        const current_tier = getTierByTierKey(user_profile ? user_profile.tier.tier_key : 'no_tier');

        let footer_signup_container_class = "";
        if (!footer_signup_container_request_sent && !footer_signup_container_request_message) {
            footer_signup_container_class = "footer-signup-container__form-group";
        } else if (footer_signup_container_request_sent && !footer_signup_container_request_message) {
            footer_signup_container_class = "footer-signup-container__input-container--loading";
        } else if (footer_signup_container_request_message) {
            footer_signup_container_class = "footer-signup-container__input-container--error text-lg-center";
        }
        return (
            <>
                <div className="clearfix"/>
                {show_offer_thank_you &&
                <OfferCodeThankYouModal
                    mobile_small={mobile_small}
                    dismissModal={this.dismissModal}
                />
                }
                {show_logout_modal &&
                    <LogoutModal
                        {...logout_modal_settings}
                    />
                }
                <LazyLoad height={400} offset={100} once={true}>
                <div className="footer-nav-container">
                    <div className="footer-nav-container__content">
                        {mobile_big &&
                            <Accordion className="footer-nav-container__accordion">
                                {_.map(config.footer_nav_container, (footer_nav_group) => {
                                    return (
                                        <Col key={footer_nav_group.id}>
                                            <FooterNavGroup
                                                footerNavGroup={footer_nav_group}
                                                eventKey={this.state.eventKey}
                                                showHideMenus={this.showHideMenus}
                                                mobile_big={mobile_big}
                                                is_b2b={is_b2b}
                                            />
                                        </Col>
                                    )
                                })}
                            </Accordion>
                        }
                        {!mobile_big &&
                            <>
                                {_.map(config.footer_nav_container, (footer_nav_group) => {
                                    return (
                                        <div className="footer-nav-container__link-group" key={footer_nav_group.id}>
                                            <FooterNavGroup
                                                footerNavGroup={footer_nav_group}
                                                is_b2b={is_b2b}
                                            />
                                        </div>
                                    )
                                })}
                            </>
                        }
                        <div className="footer-nav-container__link-group">
                            {!auth_token && !is_coupon_code_page &&
                                <div className="footer-signup-container">
                                    <label
                                        className="footer-signup-container__title"
                                        htmlFor="footer-signup-container__input"
                                    >
                                        Sign up and get up to {init.signup_offer} off your first purchase
                                    </label>
                                    <p className="footer-signup-container__text">
                                        Claim your exclusive discount code when you
                                        sign up for SMS. Term and conditions apply
                                    </p>
                                    <div className={footer_signup_container_class}>
                                        <div className="footer-signup-container__input-container-attentive">
                                            <Button
                                                className="rbg-btn-dark footer-signup-container__cta"
                                                variant="clean"
                                                disabled={disable_nl_button}
                                                aria-label="Submit Email"
                                                onClick={this.showAttentiveModal}
                                            >
                                                Sign Up
                                            </Button>
                                        </div>
                                        <div
                                            className={`d-none footer-signup-container__input-container ${!footer_signup_container_request_sent && !footer_signup_container_request_message ? "" : "d-none"}`}>
                                            <input value={this.state.footer_signup_container_input}
                                                   onChange={(event) => this.setState({
                                                       footer_signup_container_input: event.target.value.trim(),
                                                       footer_signup_container_input_invalid: false,
                                                   })}
                                                   onKeyUp={(event) => (event.key === "Enter") ? this.handleSubmit() : null}
                                                   className="footer-signup-container__input" type="email"
                                                   placeholder="Enter your email address"
                                                   id="footer-signup-container__input"
                                            />
                                            <Button
                                                onClick={this.handleSubmit}
                                                className="footer-signup-container__icon"
                                                variant="clean"
                                                aria-label="Submit Email"
                                            >
                                                <span
                                                    className="icon-arrow-right"
                                                />
                                            </Button>
                                        </div>
                                        {footer_signup_container_request_sent && !footer_signup_container_request_message &&
                                            <InlineSpinner custom_class="text-center"/>
                                        }
                                        {footer_signup_container_request_message &&
                                            <div className="footer-signup-container__bad-data">
                                                {footer_signup_container_request_message}
                                            </div>
                                        }
                                        {footer_signup_container_input_invalid &&
                                            <div className="footer-signup-container__bad-data">
                                                Please enter a valid email address
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                            <div className="footer-signup-container">
                                <div className="footer-signup-container__social-content">
                                    <a
                                        href={config.footer_nav_container_contact.social_url_facebook}
                                        aria-label="Rebag on Facebook"
                                        target="_blank"
                                        rel="nofollow noopener noreferrer"
                                    >
                                        <LazyLoad height={50} offset={100} once={true}>
                                            <RetinaImage
                                                alt="Rebag on Facebook"
                                                src={`${config.MEDIA_URL}/img/facebook-black-slim.png`}
                                                className="footer-signup-container__social-logo footer-signup-container__social-logo--facebook"
                                            />
                                        </LazyLoad>
                                    </a>
                                    <a
                                        href={config.footer_nav_container_contact.social_url_instagram}
                                        aria-label="Rebag on Instagram"
                                        target="_blank"
                                        rel="nofollow noopener noreferrer"
                                    >
                                        <LazyLoad height={50} offset={100} once={true}>
                                            <RetinaImage
                                                alt="Rebag on Instagram"
                                                src={`${config.MEDIA_URL}/img/instagram-black-slim.png`}
                                                className="footer-signup-container__social-logo footer-signup-container__social-logo--instagram"
                                            />
                                        </LazyLoad>
                                    </a>
                                    <a
                                        href={config.footer_nav_container_contact.social_url_youtube}
                                        aria-label="Rebag on Youtube"
                                        target="_blank"
                                        rel="nofollow noopener noreferrer"
                                    >
                                        <LazyLoad height={50} offset={100} once={true}>
                                            <RetinaImage
                                                alt="Rebag on Youtube"
                                                src={`${config.MEDIA_URL}/img/youtube-black-slim.png`}
                                                className="footer-signup-container__social-logo footer-signup-container__social-logo--youtube"
                                            />
                                        </LazyLoad>
                                    </a>
                                    <a
                                        href={config.footer_nav_container_contact.app_url_apple}
                                        aria-label="Download on the App Store"
                                        target="_blank"
                                        rel="nofollow noopener noreferrer"
                                    >
                                        <AppStore
                                            alt="App Store"
                                            aria-label="App Store"
                                            style={{ width: 86 }}
                                        />
                                    </a>
                                </div>
                                <LazyLoad height={650} offset={100} once={true}>
                                    <a
                                        href={`${config.host_rebag}/bloomingdales/`}
                                        aria-label="Bloomingdale's Official Retailer"
                                        target="_blank"
                                        rel="nofollow noopener noreferrer"
                                    >
                                        <RetinaImage
                                            alt="Bloomingdale's Official Retailer"
                                            src={`${config.MEDIA_URL}/img/bloomingdales-official-logo.png`}
                                            className="footer-signup-container__bloom-logo"
                                        />
                                    </a>
                                </LazyLoad>
                            </div>
                        </div>
                    </div>
                </div>
                </LazyLoad>
                <LazyLoad height={400} offset={100} once={true}>
                    <div className="footer-disclaimer-container">
                        <div className="footer-disclaimer-container__left">
                            {_.map(config.footer_disclaimer_container.disclaimers, (disclaimer) => {
                                if ((current_tier.rank >= disclaimer.min_tier) && isBetweenDates(disclaimer.start_date, disclaimer.end_date)) {
                                    return (
                                        <div key={disclaimer.id} className="footer-disclaimer-container__line">
                                            {ReactHtmlParser(disclaimer.message)}
                                        </div>
                                    );
                                }
                            })}
                            <div className="footer-disclaimer-container__line">
                                {config.footer_disclaimer_container.text}
                            </div>
                        </div>
                        <div className="footer-disclaimer-container__right">
                            <div className="footer-disclaimer-container__right-element">
                                <CreditCardsImage alt="Credit Cards" />
                            </div>
                            <div className="footer-disclaimer-container__right-element">
                                <span className="footer-disclaimer-container__copyright">{config.footer_disclaimer_container.copyright}</span>
                                {_.map(config.footer_disclaimer_container.links, (footer_disclaimer_link) => {
                                    return (
                                        <a
                                            key={footer_disclaimer_link.id}
                                            href={footer_disclaimer_link.url}
                                            className="footer-disclaimer-container__link"
                                        >
                                            {footer_disclaimer_link.label}
                                        </a>
                                    );
                                })
                                }
                            </div>
                        </div>
                    </div>
                </LazyLoad>
                <Loader />
                <TradeInLoader />
            </>
        )
    }
}


const FooterNavGroup = ({ footerNavGroup, eventKey, showHideMenus, mobile_big, is_b2b }) => {
    const { title, links, id } = footerNavGroup;
    const nextEventKey = eventKey === id ? null : id;
    const footerNavGroupUl =
        <ul className="footer-nav-container__ul">
            {_.map(links, (link, idx) => {
                if (link.hide_if_guest && !authCheck()) {
                    return null;
                }
                if (link.type === "b2b") {
                    return <FooterLinkB2b key={idx} link={link} is_b2b={is_b2b} />;
                } else if (link.url) {
                    return <FooterLink key={idx} link={link} />;
                } else {
                    if (link.id) {
                        return <FooterItem key={idx} link={link} />;
                    }
                    return (
                        <li key={idx}>
                            <div className="footer-nav-container__link" data-type={link.type}>{link.label}</div>
                        </li>
                    )
                }
            })}
        </ul>

    return (
        <>
            {!mobile_big &&
            <div className="footer-nav-container__group" data-title={title}>
                <div className="footer-nav-container__label">{title}</div>
                {footerNavGroupUl}
            </div>
            }
            {mobile_big &&
            <Card className="footer-nav-container__group">
                <Accordion.Toggle
                    as="button"
                    className="footer-nav-container__label"
                    data-title={title}
                    eventKey={id}
                    onClick={() => showHideMenus(nextEventKey)}
                >
                    {title}
                    <span className={`icon-${eventKey===id ? "minus": "plus"}`}/>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey={id}>
                    {footerNavGroupUl}
                </Accordion.Collapse>
            </Card>
            }
        </>
    );
};

const mapStateToProps = function (state) {
    const {
        show_logout_modal, logout_modal_settings, mobile_small, mobile_big, init
    } = state.appReducer;
    const {user_profile} = state.myAccountReducer;
    return {show_logout_modal, logout_modal_settings,
        mobile_small, user_profile, mobile_big, init}
};

const mapDispatchToProps = function (dispatch) {
    return bindActionCreators({
        renderAuthPopup,
        closeLoginModal
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Hooter);